var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4f0e37e81251ecec04a45fe8a8dd384358870455"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["productreviews-evaluatepage@trustpilot"]={id:"4f0e37e81251ecec04a45fe8a8dd384358870455"};
      